import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation, useParams } from "react-router-dom";
import { Footer, FloatingActions, Header } from "./components/Layout";
import Home from "./pages/Home";
import Charts from "./pages/Charts";
import MarketChart from "./pages/MarketChart";
import NotFound from "./pages/NotFound";
import ResultToday from "./pages/ResultToday";
import { SlotChart, SlotsOverview } from "./pages/Slots";
import { slugify } from "./utils/data";
import SattaMatka from "./pages/SattaMatka";
import { About, Disclaimer, HowToPlay, Privacy, Terms } from "./pages/Info";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

// Old-style URLs (e.g. /jodi-chart/KALYAN) keep working and land on the new address.
const Legacy = ({ to }) => {
  const { name } = useParams();
  return <Navigate to={`${to}/${slugify(name)}`} replace />;
};

function App() {
  return (
    <div className="rt-app">
      <ScrollToTop />
      <a className="rt-skip" href="#content">
        Skip to content
      </a>
      <Header />
      <div id="content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/charts" element={<Charts />} />
          <Route path="/jodi/:slug" element={<MarketChart key="jodi" kind="jodi" />} />
          <Route path="/pana/:slug" element={<MarketChart key="pana" kind="pana" />} />
          <Route path="/starline" element={<SlotsOverview key="SlotsOverview-starline" kind="starline" />} />
          <Route path="/starline/:slug" element={<SlotChart key="SlotChart-starline" kind="starline" />} />
          <Route path="/jackpot" element={<SlotsOverview key="SlotsOverview-jackpot" kind="jackpot" />} />
          <Route path="/jackpot/:slug" element={<SlotChart key="SlotChart-jackpot" kind="jackpot" />} />
          <Route path="/jodi-chart/:name" element={<Legacy to="/jodi" />} />
          <Route path="/panna-chart/:name" element={<Legacy to="/pana" />} />
          <Route path="/panel-chart/:name" element={<Legacy to="/pana" />} />
          <Route path="/starline-chart/:name" element={<Legacy to="/starline" />} />
          <Route path="/jackpot-chart/:name" element={<Legacy to="/jackpot" />} />
          <Route path="/aboutus" element={<Navigate to="/about" replace />} />
          <Route path="/howtoplay" element={<Navigate to="/how-to-play" replace />} />
          <Route path="/matka-result-today" element={<ResultToday />} />
          <Route path="/satta-matka" element={<SattaMatka />} />
          <Route path="/about" element={<About />} />
          <Route path="/how-to-play" element={<HowToPlay />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <Footer />
      <FloatingActions />
    </div>
  );
}

export default App;
